/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { SeoConfig } from './seo.config';

export const defaultSeoConfig: SeoConfig = {
  seo: {
    structuredData: {
      disableInDevMode: true,
    },
  },
};
